import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const InstagramIcon = (props: IconProps) => (
  <ChakraIcon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.9467 17.0975C20.9467 19.0227 19.386 20.5834 17.4608 20.5834L6.59672 20.5834C4.67149 20.5834 3.11086 19.0227 3.11086 17.0975L3.34518 6.28817C3.34518 4.36294 4.90581 2.80231 6.83104 2.80231L17.4606 2.80231C19.386 2.80231 20.9467 4.36304 20.9467 6.28838V17.0975ZM16.6783 0.813965L6.64894 0.813965C3.54474 0.813965 1.02832 3.33049 1.02832 6.43469L1.02832 17.1931C1.02832 20.2974 3.54485 22.814 6.64915 22.814L17.4074 22.814C20.5117 22.814 23.0282 20.2974 23.0282 17.1932V7.1639C23.0282 3.65694 20.1851 0.813965 16.6783 0.813965Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0276 15.5694C9.34392 15.5694 7.32756 12.7124 8.85387 9.87381C9.12202 9.37491 9.53373 8.96331 10.0326 8.69516C12.8713 7.16949 15.7278 9.18531 15.7278 11.869C15.7278 13.9127 14.0713 15.5694 12.0276 15.5694ZM12.028 6.16064C8.02269 6.16064 4.98083 10.2853 6.91939 14.5195C7.41626 15.6045 8.2903 16.479 9.37516 16.9763C13.6094 18.9173 17.7364 15.8749 17.7364 11.8688C17.7364 8.71597 15.1806 6.16064 12.028 6.16064Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9269 4.61377C17.1925 4.61377 16.5972 5.20922 16.5972 5.94355C16.5972 6.67787 17.1925 7.27311 17.9269 7.27311C18.6615 7.27311 19.2569 6.67787 19.2569 5.94355C19.2569 5.20922 18.6615 4.61377 17.9269 4.61377Z"
      fill="currentColor"
    />
  </ChakraIcon>
);
